import { useCallback } from "react";
import { useQueryClient } from "@tanstack/react-query";

export const NOTIFICATIONS_KEY = ["notifications"] as const;

/** Refetch every mounted inbox query; one already in flight is joined, never doubled. */
export function useInboxRefresh() {
  const client = useQueryClient();
  return useCallback(
    () =>
      client.refetchQueries(
        { queryKey: NOTIFICATIONS_KEY, type: "active" },
        { cancelRefetch: false },
      ),
    [client],
  );
}
